// TodaysLeave.jsx

import React, {
  useState,
  useEffect,
  useCallback,
  useContext,
} from "react";
import { TostMsg } from "../../../../App";
import { getLeaveDetailsList } from "../leaveService";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import { setLeaveRequestData } from "../../../../Services/Redux/DataTransferToAnother";
import { useDispatch } from "react-redux";

const defaultImage = "/images/placeholder_profile.png";
let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");

const TodaysLeaveSkeleton = () => (
  <>
    {[1, 2, 3].map((i) => (
      <div className="sk-card" key={i}>
        <div className="sk sk-avatar" />
        <div className="sk-inner">
          <div className="sk-row">
            <div className="sk sk-name" />
            <div className="sk sk-badge" />
          </div>
          <div className="sk-dates-row">
            <div className="sk sk-date" />
            <div className="sk sk-date" />
          </div>
        </div>
      </div>
    ))}
  </>
);

const TodaysLeave = (args) => {
  const [leaveData, setLeaveData] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  const toster = useContext(TostMsg);
  const [noData, setNoData] = useState([]);
  const [reviewLeavePolicyLink, setReviewLeavePolicyLink] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    getLeaveData();
    GetMasterSystemAlertList("Today_Leave_Tip", 1);
    GetMasterSystemAlertList("Leave_Entries", 2);
    GetMasterSystemAlertList("Leave_Policy_URL", 3);
  }, []);

  const getLeaveData = async () => {
    setIsLoading(true);
    let loggedInEmpId = userDetails?.OverseerId;
    if (loggedInEmpId != 0 ?? loggedInEmpId != null) {
      loggedInEmpId = userDetails?.OverseerId;
    } else {
      loggedInEmpId = userDetails?.EmpId;
    }
    let FilterendOfTheDay = new Date();
    FilterendOfTheDay?.setUTCHours(23, 59, 59, 999);
    const FilterEndDate = FilterendOfTheDay?.toISOString();
    const param = {
      LoggedInEmpId: loggedInEmpId,
      OrgId: userDetails?.OrgId,
      EmpId: 0,
      LeaveId: 0,
      leavecategory: "U",
      HierarchyTypeId: 3,
      FilterStartDate: new Date(),
      FilterEndDate: FilterEndDate,
      pageNumber: 1,
      pageSize: 10000,
    };
    try {
      const data = await getLeaveDetailsList(param);
      setLeaveData(data?.Data);
      setIsLoading(false);
    } catch {
      setIsLoading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const GetMasterSystemAlertList = useCallback(
    async (message, type) => {
      SystemAlerts?.filter((msg) => {
        if (msg?.Name == message && type == 0) {
          toster.current.success(msg?.Desc);
        } else if (msg?.Name == message && type == 1) {
          setMasterSystemAlertData(msg?.Desc);
        } else if (msg?.Name == message && type == 2) {
          setNoData(msg?.Desc);
        } else if (msg?.Name == message && type == 3) {
          setReviewLeavePolicyLink(msg?.Desc);
        }
      });
    },
    [SystemAlerts]
  );

  const userLeave = (value) => {
    dispatch(setLeaveRequestData(value));
  };

  return (
    <div>
      <div className="row sidecarddd">
        <div>
          <div className="col-xl-12 position-relation">
            <div className="card-body todays-leave position-relative">
              <div className="card-head-title position-relative">
                <h5>
                  Today's Leaves
                  <div className="info-tooltip-area2">
                    <img
                      src="/images/org-img/leave/info.svg"
                      className="infoimg"
                    />
                    <div className="info-tooltip-content info-area">
                      <div className="purchase-tooltip-content">
                        {masterSystemAlertData}
                      </div>
                    </div>
                  </div>
                </h5>
              </div>

              {isLoading ? (
                <TodaysLeaveSkeleton />
              ) : (
                <div className="set-scroll">
                  {leaveData?.map((el, index) => (
                    <div className="today-leave-list" key={index}>
                      <img
                        alt={el.FullName}
                        src={el.ProfileImage || defaultImage}
                        className="w-100"
                        onError={handleImageError}
                        width="32"
                        style={{ opacity: "1" }}
                      />
                      <div className="inner" onClick={() => userLeave(el)}>
                        <div className="d-flex justify-content-between">
                          <h6>{el?.EmployeeName}</h6>
                          <p className="status-btn">
                            <i className="fa fa-clock-o" aria-hidden="true"></i>{" "}
                            {el?.LeaveStatusName}
                          </p>
                        </div>
                        <div className="content">
                          <p>
                            <b>Start date:</b>{" "}
                            {moment(el?.StartDate)?.format("MMM Do YYYY")}
                          </p>
                          <p>
                            <b>End date:</b>{" "}
                            {moment(el?.EndDate)?.format("MMM Do YYYY")}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                  {leaveData?.length == 0 && (
                    <div className="no-datadiv">
                      <img src="/images/org-img/leave/no-data.png" />
                      <p>{noData}</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TodaysLeave;